export type Ticket = {
    ProductID: number;
    SeatName: string;
    TicketDateOverride: any;
    PriceName: string;
    Price: number;
    ServiceFees: number;
    Total: number;
    ModelID: string;
    IsReadonly: boolean;
    ParentModelID: string;
    ParentPropertyName: string;
    ListName: string;
    IsNewModel: boolean;
    SelfCheckForModification: boolean;
}

export type TicketInfo = {
    id: number;
    priceName: string;
    seatName: string;
    code: string;
}